import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/6a9ae49886bf03001418a492_1788611953488_2826d797/eventsphere/src/app/admin/page.tsx");
